// Sort model lists on major object profile pages (manufacturer, retailer, line,
// store, etc.) and on the Mattress Finder results page.
import {Utils} from '../utils';

export function sortResults(results, key) {
  var productList = results.parent(),
    reverse = false,
    keyType = key,
    showMax,
    djs = Utils.datajs;

  if (results.length < 2) {
    return;
  }

  productList.hide();

  if (key.substring(0, 1) === '-') {
    keyType = key.substring(1, key.length);
    reverse = true;
  }

  const getValue = function (el) {
    var val = $(el).find('input[name="' + keyType + '"]').val();
    return val && val.length ? val * 1.0 : null;
  };

  // Results with no value always go to the bottom
  const sortFunc = function (a, b) {
    var valA = getValue(a), valB = getValue(b);
    if (valA === null) return 1;
    if (valB === null) return -1;
    return reverse ? (valB - valA) : (valA - valB);
  };

  results.sort(sortFunc);
  if (productList.is(Utils.datajs('true', 'collapsed'))) {
    showMax = productList.data('js-default-max') * 1;
    results.slice(0, showMax).removeAttr('data-js-extra').show();
    results.slice(showMax).attr('data-js-extra', 'true').hide();
  }

  productList.prepend(results);
  productList.append(results.siblings('.more-results'));
  productList.fadeIn();
}

$(document).ready(function () {

  var results = $('.productList > li:not(.more-results)');

  // enable sorting
  $('#search-results-sort').change(function () {
    sortResults(results.filter(':visible, ' + Utils.datajs('true', 'extra')), $(this).find('option:selected').val());
  }).change();
});
